import { runInAction, toJS, action, observable, makeObservable } from "mobx";
import { apiRequest } from "../utils/api";
import usuariosStore from "./UsuariosStore";

class CarritoStore {
    @observable showCarritoModal = false;
    @observable carrito = [];
    @observable comentario = '';
    @observable datosInvitado = {
        name: '',
        lastName: '',
        email: '',
        phone: ''
    };

    constructor() {
        const carrito = localStorage.getItem('carrito');
        try {
            this.carrito = JSON.parse(carrito);
        } catch(e) {
            this.carrito = [];
        }
        if (!this.carrito)
            this.carrito = [];
        makeObservable(this);
    }

    persistData() {
        localStorage.setItem('carrito', JSON.stringify(toJS(this.carrito)));
    }

    clean() {
        this.carrito = [];
        this.comentario = '';
        this.datosInvitado = {
            name: '',
            lastName: '',
            email: '',
            phone: ''
        };
        this.persistData();
    }

    // Devuelve la cantidad de productos distintos
    cant() {
        return this.carrito.length;
    }

    // Devuelve la cantidad de productos
    cantTotal() {
        return this.carrito.reduce((a, b) => a + b.quantity, 0);
    }

    total() {
        return this.carrito.reduce((a, p) => a + (p.quantity * p.price), 0);
    }

    @action
    setComentario(txt) {
        this.comentario = txt;
    }

    @action
    setDatosInvitado(field, value) {
        this.datosInvitado = { ...this.datosInvitado, [field]: value };
    }

    @action
    setCantIdx(cant, idx) {
        this.carrito[idx].quantity = parseInt(cant);
        this.persistData();
    }

    @action
    async enviar() {
        const logged = usuariosStore.logged;
        // Usuario logueado: /venta (requiere token)
        // Invitado: /venta/invitado (sin autenticación; crea/asocia cliente en backend)
        const url = logged ? '/venta' : '/venta/invitado';
        const submit = {
            carrito: this.carrito,
            servicios: [], // Para gastos de envio
            comentario: this.comentario,
            retiro: 'delivery' // No implementado en districentro
        };
        if (!logged) {
            submit.cliente = {
                name: this.datosInvitado.name,
                lastName: this.datosInvitado.lastName,
                email: this.datosInvitado.email,
                phone: this.datosInvitado.phone
            };
        }
        /* Para cuando haya tipos de delivery
        if (this.isDelivery && this.deliveryCost)
            submit['servicios'] = [ { cant: 1, concepto: 'Costo de envio', precio: this.deliveryCost } ]
         */
        try {
            const ret = await apiRequest(url, submit, { reject: true });
            this.clean();
            return [false, ret.id];
        } catch(e) {
            console.error(e);
            try {
                const parsed = typeof e === 'string' ? JSON.parse(e) : e;
                return [true, parsed.msg || parsed.message || "Error generando la orden."];
            } catch(err) {
                console.error('error json', err);
                return [true, typeof e === 'string' ? e : "Error generando la orden."];
            }
        }
    }

    @action
    borrarIdx(idx) {
        this.carrito.splice(idx, 1);
        this.persistData();
    }

    @action
    modal(value) {
        if (value !== undefined) {
            this.showCarritoModal = value;
        } else {
             this.showCarritoModal = !this.showCarritoModal;
        }
    }

    @action
    agregar(producto, cant = {}) {
        console.log('agregar', producto, cant);
        const prod = this.carrito.filter(p => p.id == producto.id);
        const total = Object.values(cant).reduce((a, b) => a + b, 0);
        if (prod.length > 0) {
            const idx = this.carrito.findIndex(p => p.id == producto.id);
            this.carrito[idx].quantity += total;
            Object.keys(cant).forEach(talle => {
                if (!this.carrito[idx].quantity_extended)
                    this.carrito[idx].quantity_extended = {};
                if (!this.carrito[idx].quantity_extended[talle])
                    this.carrito[idx].quantity_extended[talle] = 0;
                if (this.carrito[idx].quantity_extended[talle] + cant[talle] >= producto.max[talle].stock) {
                    this.carrito[idx].quantity_extended[talle] = producto.max[talle].stock;
                    this.carrito[idx].quantity = producto.max[talle].stock;
                } else {
                    this.carrito[idx].quantity_extended[talle] += cant[talle];
                }
            });
        } else {
            this.carrito.push({...producto, quantity: total, quantity_extended: cant});
        }
        this.persistData();
    }
}
const carritoStore = new CarritoStore();
export default carritoStore;
